module.exports = __webpack_public_path__ + "static/media/2_PoA-uchastie-OSA_20150626.70b893f4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/2_PoA-uchastie-OSA_20150626.pdf
// module id = 185
// module chunks = 0